<template>
  <v-container fluid grid-list-md class="pa-0">
    <v-layout row wrap class="pt-1">
      <v-flex xs12 class="pb-0">
        <v-list-tile-content>
          <v-flex xs10 class="pa-0 pb-2 text-xs-left">
            <div class="f-20 t-color-grey-d font-weight-bold">
              {{ cls_detail.name }} <span class="f-14"></span>
            </div>
            <div class="f-14 t-color-grey-l">
              {{ cls_detail.description }}
            </div>
          </v-flex>

          <!--<div class="f-15 text-primary font-weight-bold">Teacher name</div>-->
          <!--<div class="f-15 text-primary font-weight-bold">Date , Time</div>-->
        </v-list-tile-content>
        <!-- <v-card-actions class="pa-0">
          <v-btn small icon @click="viewcls = true,viewclsData=clss" class= "w-100 no-shadow card-r text-primary text-capitalize">
            <v-icon class="text-primary">visibility</v-icon></v-btn>
        </v-card-actions> -->
      </v-flex>
    </v-layout>
    <v-flex>
      <v-flex class="pa-0 text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-circular>
      </v-flex>
      <div v-if="teacherTimes.length == 0 && !loading">
        <v-alert :value="true" type="info">
          No available time right now
        </v-alert>
      </div>
      <v-expansion-panel
        v-if="!loading"
        v-for="time in teacherTimes"
        class="no-shadow mb-3 card-r"
        v-show="!searching"
      >
        <v-expansion-panel-content expand-icon="mdi-menu-down">
          <template v-slot:header>
            <div class="f-14 font-weight-bold textColor">
              {{ time[0].class_location }}
            </div>
          </template>
          <v-card
            v-if="i < 3"
            v-for="(clss, i) in time"
            :key="i"
            @click="book = true"
            class="ma-2 card-r no-shadow pt-1 pb-1 grey lighten-3"
          >
            <v-list tow-line subheader class="pa-0 transparent">
              <v-list-tile avatar>
                <v-list-tile-avatar size="35px" color="#077FFF">
                  <img class="objec-fit br-1" :src="clss.teacher_image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="t-color-grey-d font-weight-bold">
                    {{ clss.date }}
                    {{ clss.time_from }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="t-color-grey-l"
                    ><span class="text-grey-dark f-15">{{
                      clss.tName
                    }}</span></v-list-tile-sub-title
                  >
                </v-list-tile-content>
                <v-card-actions class="pa-0">
                  <v-btn
                    small
                    icon
                    @click="(viewcls = true), (viewclsData = clss)"
                    class="w-100 no-shadow card-r text-primary text-capitalize"
                  >
                    <v-icon class="text-primary">visibility</v-icon></v-btn
                  >
                </v-card-actions>
              </v-list-tile>
            </v-list>
          </v-card>
          <v-flex v-if="viewMoreButtonStatus">
            <v-btn
              class="w-100 ma-0 no-shadow grey lighten- text-white"
              round
              @click="viewMoreTime(time)"
              >view more
            </v-btn>
          </v-flex>

          <!--<v-card-text class="grey lighten-3 f-15">-->
          <!--<span class="font-weight-bold">Location Description </span>-->
          <!--Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et-->
          <!--dolore magna aliqua. Ut enim ad minim veniam-->
          <!--</v-card-text>-->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
    <v-dialog
      class="pa-0 border-r card-r w-100 z-10"
      v-model="viewcls"
      width="500"
    >
      <v-card class="card-r grey lighten-4 no-shadow">
        <v-layout row xs12 justify-center>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 class="ma-2">
                <v-btn
                  small
                  icon
                  @click="viewcls = false"
                  class="right grey--text f-15"
                  ><v-icon>close</v-icon></v-btn
                >
                <div
                  class="text-sm-left pt-1 f-20 pl-2 font-weight-bold t-color-grey-l"
                >
                  Teacher full details
                </div>
              </v-flex>
              <v-divider></v-divider>
            </v-layout>
            <v-container fluid grid-list-md>
              <v-card class=" no-shadow nope card-r text-xs-left pa-2">
                <v-layout xs12 row wrap class="py-2">
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark"
                      >Teacher:</span
                    >
                    <span class="f-15 font-weight-bold text-primary">{{
                      viewclsData.teacher_name
                    }}</span>
                  </v-flex>
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark"
                      >Duration :</span
                    >
                    <span class="f-15 font-weight-bold text-primary"
                      >{{ viewclsData.minutes }}Min</span
                    >
                  </v-flex>
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark"
                      >Date:
                    </span>
                    <span class="f-15 font-weight-bold text-primary">{{
                      viewclsData.date
                    }}</span>
                  </v-flex>
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark"
                      >time:
                    </span>
                    <span class="f-15 font-weight-bold text-primary">{{
                      viewclsData.time_to
                    }}</span>
                  </v-flex>
                  <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                    <span class="f-15 font-weight-bold text-grey-dark"
                      >Location:
                    </span>
                    <span class="f-15 font-weight-bold text-primary">{{
                      viewclsData.class_location
                    }}</span>
                  </v-flex>
                  <v-flex xs12 class="text-xs-left py-0 ">
                    <!-- <span class="f-17 font-weight-bold text-grey-dark">Description:</span>
                    <span class="f-15 text-primary font-weight-bold pb-2">{{viewclsData}}</span> -->
                    <!--<p class="descriptionList" v-for="tag in ClassData.tags">{{tag.key}} - {{tag.description}}</p>-->

                    <p
                      v-if="index < 2"
                      v-for="(tag, index) in cls_detail.tags"
                      class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3"
                    >
                      {{ tag.key }} - {{ tag.description }}
                    </p>

                    <span v-show="read">
                      <p
                        v-if="index >= 2"
                        v-for="(tag, index) in cls_detail.tags"
                        class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3"
                      >
                        {{ tag.key }} - {{ tag.description }}
                      </p>
                    </span>
                    <v-btn
                      v-show="!read"
                      @click="read = true"
                      class="w-100 card-r ma-0 text-capitalize no-shadow"
                      small
                      >readmore</v-btn
                    >
                    <v-btn
                      v-show="read"
                      @click="read = false"
                      class="w-100 card-r ma-0 text-capitalize no-shadow"
                      small
                      >less</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import api from "@/utils/backend-api";
let self;
export default {
  props: ["cls_detail"],
  data() {
    return {
      loading: false,
      teacherTimes: [],
      viewcls: false,
      viewclsData: "",
      viewMoreButtonStatus: true,
      read: false,
      searching: false,
      book: false,
      filtering: false,
      rating: 3,
      selectedFilter: "",
      tabs: "all",
      classTypes: [
        { text: "Location Name 1" },
        { text: "Location Name 2" },
        { text: "Location Name 3" }
      ],
      cards: []
    };
  },
  created: function() {
    self = this;
    this.getTimeByLocation();
  },
  methods: {
    viewMoreTime(time) {
      console.log(time);
      this.viewMoreButtonStatus = false;
      let data = {
        bookType: "theory",
        times: time
      };
      this.$emit("viewMoreTime", data);
    },
    getTimeByLocation() {
      self.loading = true;
      api
        .postData("booking_2/admin/getTimeByLocation", {
          module_id: this.cls_detail.id,
          package_id: this.cls_detail.package_id,
          student_id: this.$route.params.id
        })
        .then(res => {
          self.loading = false;
          self.teacherTimes = res.data.times;
        })
        .catch(err => {
          self.loading = false;
          self.teacherTimes = [];
        });
    }
  }
};
</script>
<style>
.rate1 .v-rating .navigation .far,
.fa {
  margin-left: 0px !important;
  padding: 5px !important;
  font-size: 19px !important;
}
.calender-tabs .v-tabs__wrapper {
  height: 20px !important;
}
.calender-tabs .v-tabs__div {
  font-size: 10px !important;
}
.v-calendar-weekly__day-month {
  background: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/student/new/theorybook.vue